import React, { useMemo } from "react";
import BetButton from "./BetButton";
import {
  BetBlockWrapper,
  BetBoxWrapper,
  ActionButton,
  ConfigsWrapper,
} from "../ElementsStyles";
import BetInput from "./BetInput";
import AutoPilot from "../../auto/Autopilot";
import { useTranslation } from "../../../../locale/context";
interface BetBlock_props {
  firstBlock?: boolean;
  stake: string;
  active?: boolean;
  handleAutoConfigs: () => void;
  handleStake?: (s: string) => void;
  autoPilotNumber: string;
  handleBet: (s: string, e: any) => void;
  cashoutStake: number;
  footerState: any;
  disabled: boolean;
  isPlaying: boolean;
  isJackpot: boolean;
  popup: boolean;
}

export default function BetBlock({
  firstBlock,
  stake,
  active,
  handleAutoConfigs,
  handleStake,
  autoPilotNumber,
  handleBet,
  cashoutStake,
  footerState,
  disabled,
  isPlaying,
  isJackpot,
  popup,
}: BetBlock_props) {
  const { t } = useTranslation();
  const languagePack = useMemo(() => {
    return {
      autopilot: t("button.autopilot"),
      autopilotClose: t("button.autopilotClose"),
    };
  }, [t]);

  const ActionBTNContent = active
    ? languagePack.autopilotClose
    : languagePack.autopilot;

  return (
    <BetBlockWrapper className="BetBlockWrapper" firstBlock={firstBlock}>
      <ActionButton
        className="ActionButton"
        firstBlock={firstBlock}
        onClick={() => !disabled && handleAutoConfigs()}
        active={active}
        disabled={disabled || isJackpot}
      >
        {ActionBTNContent}
      </ActionButton>
      <ConfigsWrapper
        className="configs-wrapper"
        firstBlock={firstBlock}
        popup={popup}
      >
        {active && (
          <AutoPilot
            firstBlock={firstBlock}
            autoPilotNumber={autoPilotNumber}
            disabled={disabled || isJackpot}
            isPlaying={isPlaying}
          />
        )}
        <BetBoxWrapper className="BetBoxWrapper">
          <BetInput
            handleStake={handleStake}
            stake={stake}
            disabled={isPlaying || isJackpot}
          />
          <BetButton
            handleBet={handleBet}
            autoPilotNumber={autoPilotNumber}
            stake={stake}
            cashoutStake={cashoutStake}
            footerState={footerState}
            disabled={disabled || isJackpot}
          />
        </BetBoxWrapper>
      </ConfigsWrapper>
    </BetBlockWrapper>
  );
}
